export default __webpack_public_path__ + "assets/67e4952b6e580669e1ed0c4b5b7c5fe3.svg";